import classNames from "classnames";
import Image from "next/image";

interface ScreenshotErrorStateProps extends React.HTMLAttributes<HTMLDivElement> {
  verbose?: boolean;
}

const ScreenshotLoadingState = ({ className, ...props }: ScreenshotErrorStateProps) => {
  return (
    <div className={classNames("flex flex-1 flex-col items-center justify-center", className)} {...props}>
      <Image
        alt="Loading"
        className="w-10 opacity-50 grayscale"
        height="40"
        src="/_public-pages-service/vp-logo.gif"
        style={{ filter: "grayscale(100%)" }}
        width="40"
      />
    </div>
  );
};

export default ScreenshotLoadingState;
